import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendarpopoutmodal',
  templateUrl: './calendarpopoutmodal.component.html',
  styleUrls: ['./calendarpopoutmodal.component.css']
})
export class CalendarpopoutmodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
